var React = require('react');

function SinglePurchase (props) {
    return React.createElement("svg",props,React.createElement("path",{"stroke":"#737680","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","strokeWidth":"1.2","d":"M12.897 14.432H3v-3.049c0-.857.513-1.63 1.305-1.96.802-.332 1.996-.646 3.643-.646 1.647 0 2.841.314 3.644.647.792.328 1.305 1.102 1.305 1.96v3.048zM7.949 6.655c1.561 0 2.827-1.266 2.827-2.827C10.776 2.266 9.51 1 7.95 1 6.387 1 5.12 2.266 5.12 3.828c0 1.561 1.266 2.827 2.828 2.827z"}));
}

SinglePurchase.defaultProps = {"width":"16","height":"16","fill":"none","viewBox":"0 0 16 16"};

module.exports = SinglePurchase;

SinglePurchase.default = SinglePurchase;
